<template>
  <div id="app">
    <router-view/>
    <Loading />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue';

export default {
  name: 'app',
  components: { Loading }

}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
